import useMutationCall from "../../../hooks/useMutationCall";
import { usePatchProgressMutation } from "../projectsSlice";

const useProgressPatch = () => {
  return useMutationCall(usePatchProgressMutation);
};

export default useProgressPatch;
